export default __webpack_public_path__ + "static/media/cog-solid.ddc50278.svg";